module.exports = {
	"config": {
		"siteTitle": "Acoustic Cleaning Systems, LLC",
		"linkPrefix": "/",
		"googleAnalyticsId": "UA-101798931-1",
		"rootUrl": "https://acousticcleaning-com.firebaseapp.com",
		"organizationName": "Acoustic Cleaning Systems, LLC",
		"logoPath": "/acoustic-cleaning-systems-logo.png",
		"logoWidth": 291,
		"logoHeight": 82
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "",
				"stem": "_template",
				"path": "_template.js"
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "about.js",
				"ext": "js",
				"name": "about",
				"extname": ".js",
				"basename": "about.js",
				"dirname": "",
				"stem": "about",
				"path": "about.js"
			},
			"requirePath": "about.js",
			"path": "/about/",
			"data": {
				"menuLabel": "About",
				"menuShortDescription": "About for Acoustic Cleaning Services, Inc."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "applications.js",
				"ext": "js",
				"name": "applications",
				"extname": ".js",
				"basename": "applications.js",
				"dirname": "",
				"stem": "applications",
				"path": "applications.js"
			},
			"requirePath": "applications.js",
			"path": "/applications/",
			"data": {
				"menuLabel": "Applications",
				"menuShortDescription": "Applications for Acoustic Cleaning Services, Inc."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {
				"menuLabel": "Home",
				"menuShortDescription": "Acoustic Cleaning Services, Inc."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "learn.js",
				"ext": "js",
				"name": "learn",
				"extname": ".js",
				"basename": "learn.js",
				"dirname": "",
				"stem": "learn",
				"path": "learn.js"
			},
			"requirePath": "learn.js",
			"path": "/learn/",
			"data": {
				"menuLabel": "Learn",
				"excludeFromMenu": true,
				"menuShortDescription": "Learn for Acoustic Cleaning Services, Inc."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "products",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "products",
				"stem": "_template",
				"path": "products/_template.js"
			},
			"requirePath": "products/_template.js",
			"templatePath": "/products/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "products",
				"base": "ac-220.yaml",
				"ext": "yaml",
				"name": "ac-220",
				"extname": ".yaml",
				"basename": "ac-220.yaml",
				"dirname": "products",
				"stem": "ac-220",
				"path": "products/ac-220.yaml"
			},
			"requirePath": "products/ac-220.yaml",
			"path": "/products/ac-220/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "products",
				"base": "ac-230.yaml",
				"ext": "yaml",
				"name": "ac-230",
				"extname": ".yaml",
				"basename": "ac-230.yaml",
				"dirname": "products",
				"stem": "ac-230",
				"path": "products/ac-230.yaml"
			},
			"requirePath": "products/ac-230.yaml",
			"path": "/products/ac-230/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "products",
				"base": "ac-75-c.yaml",
				"ext": "yaml",
				"name": "ac-75-c",
				"extname": ".yaml",
				"basename": "ac-75-c.yaml",
				"dirname": "products",
				"stem": "ac-75-c",
				"path": "products/ac-75-c.yaml"
			},
			"requirePath": "products/ac-75-c.yaml",
			"path": "/products/ac-75-c/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "products",
				"base": "ac-75.yaml",
				"ext": "yaml",
				"name": "ac-75",
				"extname": ".yaml",
				"basename": "ac-75.yaml",
				"dirname": "products",
				"stem": "ac-75",
				"path": "products/ac-75.yaml"
			},
			"requirePath": "products/ac-75.yaml",
			"path": "/products/ac-75/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "products",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "products",
				"stem": "index",
				"path": "products/index.js"
			},
			"requirePath": "products/index.js",
			"path": "/products/",
			"data": {
				"menuLabel": "Products",
				"menuShortDescription": "Products for Acoustic Cleaning Services, Inc."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "products",
				"base": "magnum-c.yaml",
				"ext": "yaml",
				"name": "magnum-c",
				"extname": ".yaml",
				"basename": "magnum-c.yaml",
				"dirname": "products",
				"stem": "magnum-c",
				"path": "products/magnum-c.yaml"
			},
			"requirePath": "products/magnum-c.yaml",
			"path": "/products/magnum-c/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "products",
				"base": "magnum.yaml",
				"ext": "yaml",
				"name": "magnum",
				"extname": ".yaml",
				"basename": "magnum.yaml",
				"dirname": "products",
				"stem": "magnum",
				"path": "products/magnum.yaml"
			},
			"requirePath": "products/magnum.yaml",
			"path": "/products/magnum/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "projects.js",
				"ext": "js",
				"name": "projects",
				"extname": ".js",
				"basename": "projects.js",
				"dirname": "",
				"stem": "projects",
				"path": "projects.js"
			},
			"requirePath": "projects.js",
			"path": "/projects/",
			"data": {
				"menuLabel": "Projects",
				"excludeFromMenu": true,
				"menuShortDescription": "Projects by Acoustic Cleaning Services, Inc."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "service.js",
				"ext": "js",
				"name": "service",
				"extname": ".js",
				"basename": "service.js",
				"dirname": "",
				"stem": "service",
				"path": "service.js"
			},
			"requirePath": "service.js",
			"path": "/service/",
			"data": {
				"menuLabel": "Parts & Service",
				"menuShortDescription": "Service for Acoustic Cleaning Services, Inc."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "technical.js",
				"ext": "js",
				"name": "technical",
				"extname": ".js",
				"basename": "technical.js",
				"dirname": "",
				"stem": "technical",
				"path": "technical.js"
			},
			"requirePath": "technical.js",
			"path": "/technical/",
			"data": {
				"menuLabel": "Applications",
				"excludeFromMenu": true,
				"menuShortDescription": "Technical Docs for Acoustic Cleaning Services, Inc."
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 384
// module chunks = 0